import React from 'react';
import styled from 'styled-components';

// import LogoSecti from '../../assets/img/dj-logos/secti-b-v.svg';
// import LogoSecti from '../../assets/img/dj-logos/secti-b-v_bandeira.png';
import LogoSecti from '../../assets/img/dj-logos/secti-b-v_2023.png';
// import LogoInova from '../../assets/images/logo-edu-b.png';
const LogoInova = "img/logos_2024/logo_inova_ma_dvetor.svg"

function MFoot(){
    // const {  } = props;
    return (<>
      <div className="sep-top"/>
      <MFootConteiner id='MFoot'>
        <div className="devs">
          <p>Plataforma desenvolvida por:</p>
          <p className="dev">Eduardo S. Santos & Sophia Pinto</p>
          <p className=""> Copyright©2020-{(new Date()).getFullYear()}</p>
          <p className=""> Todos os direitos reservados.</p>
        </div>
        <div className="mf-logos">
          <img className='mf-inova' alt="Inova Maranhão Eixo Educação" src={LogoInova}/>
          <div className='linha-v'/>
          <img className='mf-secti' alt="Secti" src={LogoSecti}/>
        </div>
        <nav className="footer-nav">
          <div className="mapa">
            <p>Ler <a href="/Sobre">Sobre</a> o projeto</p>
            <p>Ver <a href="/Cadastros">Cadastrados</a> no Maranhão</p>
            <p>Ver <a href="/Ranking">Ranking</a> da plataforma</p>
            <p>Entrar em <a href="/Duvidas">Contato</a> (use para tirar dúvidas)</p>
            <p>{" "}</p>
          </div>
          <div className="referencias">
            <a href="/termos">Termos e Condições de uso</a>
            {" e "}
            <a href="/termos">Política de Privacidade</a>
          </div>
          <div className="atribuicoes">
            <p>Uicons by <a href="https://www.flaticon.com/uicons">Flaticon</a></p>
          </div>
        </nav>
      </MFootConteiner>
    </>);
      }


export default MFoot;

const MFootConteiner = styled.div`
    position: relative;
    width: 100%;
    min-height: 255px;
    padding-top:10px;
    background: #707070;

    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;

    color: #FFFFFF;

    a {
        color: antiquewhite;
    }

    .devs{

        /* or 133% */
        display: flex;
        align-items: center;
        text-align: center;

        /* position: absolute; */
        min-width: 330px;
        max-width:100vw;
        height: 73px;
        /* right: 13px;
        top: 15px; */
        /* padding: 15px 13px; */
        padding: 20px 13px 10px;
        flex-direction: column;
        flex-wrap: nowrap;
        justify-content: center;
    }

    .dev{
        font-weight: bold;
    }
    @media (min-width:500px) {
        .devs{
            align-items: flex-end;
            padding-right: 5vw;
        }
    }
    @media (min-width:900px) {
        & {
            font-size:2rem;
            ${'' /* color:red!important; */}
        }
        .devs{
            padding-top: 60px;
        }
    }
    .mf-logos{
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: space-around;
        align-content: center;
        flex-wrap: nowrap;
        flex-direction: row;

        max-width: 500px;
        min-width: 360px;
        margin: 0 auto;
    }

    .mf-inova {
        width: 152px;
        height: 110px;
    }
    .mf-secti {
        width: 153.91px;
        height: 152px;
    }

    .linha-v {
        height: 167px;
        background-color: #2e2e29;
        width: 1px;
        /* border: 1px solid #000000; */
        /* border-right: 1px solid #707070; */

    }

    nav {
        padding: 20px;
        display: flex;
        font-size: 15px;
        justify-content: space-around;
        justify-content: space-evenly;
        align-items: center;
    }

    nav div{
        padding:10px;
    }
    @media (max-width:700px) {
        nav {
            display:block;
            /*flex-direction:column;*/
        }
    }
`;
